module.exports = __webpack_public_path__ + "img/i_location_input_gray.36c08430.svg";